<template>
  <v-container>
    <div class="limited-width mx-auto">
      <v-row class="">

        <v-col :cols="12" class="d-flex justify-center align-center" >
          <div class="mx-auto text-center">
            <v-img class="mx-auto" style="border-radius: 50%; aspect-ratio: 1; max-height: 200px; max-width: 200px;" :src="imageData" v-if="imageData && !changingPhoto" />
            <v-skeleton-loader class="mx-auto" v-else type="image" :loading="false" />
            <div class="caption mx-auto">
              Profile Photo
            </div>
            <v-btn color="primary" class="mx-auto" @click="changingPhoto = true">
              Change Photo
            </v-btn>
          </div>
        </v-col>

        <v-dialog v-model="changingPhoto" persistent overlay-opacity="1.0" max-width="600px">
          <v-card>
            <v-card-title>
              Change Photo
            </v-card-title>
            <v-card-text>
              <template v-if="dialogImageData">
                <cropper
                    class="cropper"
                    ref="cropper"
                    :stencil-props="{
                      aspectRatio: 1
                    }"
                    :src="dialogImageData"
                />
                <v-btn text @click="dialogImageData = null" :disabled="dialogLoading">Switch Photo</v-btn>
              </template>
              <template v-else>
                <div style="border: 1px dashed black;" class="text-center pa-16 drop-zone" @drop.prevent="drop" @dragenter.prevent @dragover.prevent>

                  <div>
                    <div class="text--secondary text-body-1">Drag and drop photo</div>
                    <div class="caption pt-2">or</div>
                    <v-btn color="primary" text @click="openFileInputPicker">Select photo</v-btn>
                    <input ref="fileInput" id="fileInputId" type="file" style="visibility: hidden; width: 0; height: 0;" @change="handleFileInputChange" />
                  </div>

                </div>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="cancelChangePhoto" :disabled="dialogLoading">
                Cancel
              </v-btn>
              <v-spacer />
              <v-btn :disabled="!dialogImageData || dialogLoading" :loading="dialogLoading" @click="dialogSubmit" color="primary">
                Submit
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-row>
      <v-row class="">

        <v-col :cols="12" :md="6">
          <v-text-field
              outlined
              label="Name"
              placeholder="ie, Jane Doe"
              hint="Provide your name"
              :persistent-hint="true"
              v-model="profile.name"
          />
        </v-col>
        <v-col :cols="12" :md="6">
          <v-text-field
              outlined
              label="Email"
              placeholder="ie, jane@amazingrealty.com"
              hint="Provide your email address"
              :persistent-hint="true"
              v-model="profile.email"
          />
        </v-col>
        <v-col :cols="12" :md="6">
          <v-text-field
              outlined
              label="Phone Number"
              placeholder="555 555 5555"
              hint="Enter the phone number exactly how you want it to appear."
              :persistent-hint="true"
              v-model="profile.phone"
          />
        </v-col>
<!--        <v-col :cols="12">-->
<!--          <v-textarea-->
<!--              outlined-->
<!--              label="Provide the message you'd like shared in branded links.  "-->
<!--              placeholder=""-->
<!--              :hint="`${profile.message.length} / 100 characters. Use {videoName} anywhere you want the video name you specify when you upload the video inserted.`"-->
<!--              :persistent-hint="true"-->
<!--              v-model="profile.message"-->
<!--          />-->
<!--        </v-col>-->

        <v-col :cols="12">
          <v-btn class="float-end" color="primary" @click="submit"
                 :loading="loading"
                 :disabled="loading"
          >
            Submit
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios'
import Api from "@/services/aws/Api";
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css';

export default {
  name: "Branding",
  components: {
    Cropper
  },
  data() {
    return {
      hadExistingProfileData: false,
      hasCurrentProfilePhoto: false,
      loading: false,
      dialogLoading: false,
      changingPhoto: false,
      imageData: null,
      dialogImageData: null,
      profile: {
        name: '',
        email: '',
        phone: '',
        message: 'Welcome to {videoName}! Torvue to offer a 360° video tours. You can swipe to look around while we explore the home together. If you need any help buying or selling a home, please reach out.'
      }
    }
  },
  methods: {
    handleFileInputChange(event) {

      const fileList = [] //.filter(x => { return x && x.type.match('image.*') })
      for(let f of event.target.files) {
        if(f && f.type.match('image.*')) {
          fileList.push(f)
        }
      }

      if(fileList.length === 0) {
        this.$swal({
          title: 'Unsupported file type',
          text: 'Please select an image file.'
        })
        return
      }

      const reader = new FileReader()
      reader.addEventListener('load', (ee) => {
        this.dialogImageData = ee.target.result
      })
      reader.readAsDataURL(fileList[0])
    },
    openFileInputPicker() {
      this.$refs.fileInput.click()
    },
    async submit() {
      try {
        this.loading = true

        let e
        await Api.updateProfile(this.$store.state.credentials, this.profile).catch(err => {
          e = err
        })
        if(e) throw e

        if(this.hadExistingProfileData) {
          this.$swal({
            title: 'Profile Updated',
            text: 'Videos processed previously will continue to use your old profile data.  New videos will use your new profile data.'
          })
        }

      } catch (e) {
        await this.$swal(e.toString())
      } finally {
        this.loading = false
      }
    },
    async dialogSubmit() {
      try {
        this.dialogLoading = true
        const {
          coordinates, image, visibleArea, canvas
        } = this.$refs.cropper.getResult()
        this.imageData = canvas.toDataURL('image/webp')

        const requestImageData = this.imageData.split(',')[1]

        let e
        await Api.updateProfilePhoto(this.$store.state.credentials, {
          imageData: requestImageData
        }).catch(err => {
          e = err
        })
        if(e) {
          throw e
        }

        this.dialogImageData = null
        this.changingPhoto = false

        if(this.hasCurrentProfilePhoto) {
          this.$swal({
            title: 'Profile Photo Changed',
            text: 'Your old profile photo may still appear for up to 24 hours.  Videos processed previously will continue to use your old profile photo.  New videos will use your new profile photo.'
          })
        }

      } catch (e) {
        await this.$swal(e.toString())
      } finally {
        this.dialogLoading = false
      }
    },
    async init() {
      await this.$store.state.loadAccountPromise
      await this.loadProfile()
      this.loading = false
    },
    async cancelChangePhoto() {
      this.changingPhoto = false
      await this.init()
    },
    drop(event) {
      const fileList = [] //.filter(x => { return x && x.type.match('image.*') })
      for(let f of event.dataTransfer.files) {
        if(f && f.type.match('image.*')) {
          fileList.push(f)
        }
      }

      if(fileList.length === 0) {
        if(fileList.length === 0) {
          this.$swal({
            title: 'Unsupported file type',
            text: 'Please select an image file.'
          })
        }
        return
      }

      const reader = new FileReader()
      reader.addEventListener('load', (event) => {
        this.dialogImageData = event.target.result
      })
      reader.readAsDataURL(fileList[0])
    },
    async loadProfile() {
      const account = this.$store.state.account
      const accountId = account.accountId

      try {
        let err
        const response = await axios.get(`https://${process.env.VUE_APP_USER_DATA_URL}/${accountId}/profile.webp`, {
          responseType: 'blob',
          // headers: { //disables browser cache... causes cloudfront 403.
          //   // 'Cache-Control': 'max-age=1',
          //   // 'Pragma': 'no-cache',
          //   // 'Expires': 0
          // }
        }).catch(e => {
          err = e
        })
        if(err) {
          throw err
        }

        if(response) {
          this.imageData = URL.createObjectURL(response.data)
          this.hasCurrentProfilePhoto = true
        }
      } catch(e) {
        console.log('failed to get profile image')
        console.log(e.toString())
      }

      if(account.profile) {
        if(Object.keys(account.profile).length > 0) {
          this.hadExistingProfileData = true
        }
        this.profile = account.profile
      }
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style>
  .limited-width {
    max-width: 600px;
  }
  .drop-zone {
    cursor: grab;
  }
  .drop-zone.dragging {
    cursor: grabbing;
  }

  .vue-preview {
    border-radius: 50%;
  }

  .cropper {
    height: 55vh;
    /*border-radius: 50%;*/
  }
</style>